import { z } from 'zod'

export const ChatHistoryMessageSchema = z.object({
  role: z.enum(['user', 'assistant', 'system']),
  content: z.string().max(10_000),
})

export const ChatRequestSchema = z.object({
  message: z.string().trim().min(1, 'message is required').max(10_000),
  history: z.array(ChatHistoryMessageSchema).max(50).default([]),
})

export type ChatHistoryMessage = z.infer<typeof ChatHistoryMessageSchema>
export type ChatRequest = z.infer<typeof ChatRequestSchema>

export const ChatResponseSchema = z.object({ response: z.string() })
export type ChatResponse = z.infer<typeof ChatResponseSchema>
